import React from 'react';

class ConnectedComponent extends React.Component {
    constructor(props) {
        super(props);
        //if store has value relative to this component, initialize the state value
        this.state = { value: props.value || "", error: "" };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value)//if store's value relative to this component change, update the state value
            this.setState({ value: {...newProps.value} });
        else if (!newProps.value)//in case the store does not have any value for this component, just clear it
            this.setState({ value: "" });
        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: {...newProps.error} });
    }

    onUpdateState = (value) => {
        this.setState({ value });
    }

    onUpdateStore = (value, validate, actionName) => {
        this.updateStore(value, validate,actionName);
    }

    updateStore(value, validate, actionName) {
        let error = '';
        if (typeof (this.validate) === 'function')
            error = this.validate(value);
            
        this.setState({ value, error });

        this.props.dispatch({ type: actionName, value, name: this.props.name });
    }
}

export default ConnectedComponent;